import { Null, Record, Static, String as RTString, Undefined } from 'runtypes';

export const Address = Record({
  street1: RTString,
  street2: RTString.Or(Undefined).Or(Null),
  street3: RTString.Or(Undefined).Or(Null),
  state: RTString,
  zip: RTString,
  zip4: RTString.Or(Undefined).Or(Null),
  city: RTString
});

export type StaticAddress = Static<typeof Address>;
